import Footer from '../../../../footer/containers/FooterContainer';
import Header from '../../../../header/containers/Header';
import {ApplicationContainer} from '../../../../ui';
import CourseCreationContainer from '../containers/CourseCreationContainer';
import css from '../styles/CreateCoursePageLayout.module.css';

interface CreateCoursePageLayoutProps {
  children: Array<JSX.Element> | JSX.Element;
}

const CreateCoursePageLayout = ({children}: CreateCoursePageLayoutProps) => {
  return (
    <CourseCreationContainer>
      <ApplicationContainer>
        <div className={css.wrapper}>
          <Header />
          <div className={css.main}>{children}</div>
          <Footer />
        </div>
      </ApplicationContainer>
    </CourseCreationContainer>
  );
};

export default CreateCoursePageLayout;
